import { GenericError } from '@cian/peperrors/shared';

export interface IValidationErrors {
  customerPhone?: string;
  time?: string;
  validationCode?: string;
  phoneNumberIsInvalid?: string;
  tryValidationCodeLater?: string;
  missingValidationCode?: string;
}

interface IValidationErrorParams {
  domain: string;
  message: string;
  errors: IValidationErrors;
}

export class ValidationError extends GenericError {
  public readonly errors: IValidationErrors;

  /* istanbul ignore next */
  public constructor({ domain, message, errors }: IValidationErrorParams) {
    super({
      domain,
      message,
      type: 'ValidationError',
    });

    Object.setPrototypeOf(this, ValidationError.prototype);
    this.errors = errors;
  }
}
